import styled from 'styled-components';

export const Header = styled.div`
  margin-bottom: ${({ theme }) => theme.space[6]};
  h6 {
    margin-bottom: ${({ theme }) => theme.space[3]} !important;
  }
`;
